import { render, staticRenderFns } from "./NewAgent.vue?vue&type=template&id=a597f31a&scoped=true"
import script from "./NewAgent.vue?vue&type=script&lang=js"
export * from "./NewAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a597f31a",
  null
  
)

export default component.exports